import * as actionTypes from '../actions/types';

export const actualizarAtriutoSnackMensaje = (objeto) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_ATRIBUTOS_SNACK,
        payload: objeto,
    });
};
